import { render, staticRenderFns } from "./MediakitTagsFilters.vue?vue&type=template&id=38f6d150&"
import script from "./MediakitTagsFilters.vue?vue&type=script&lang=js&"
export * from "./MediakitTagsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports